import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, provide, Ref, ref } from 'vue';
import {
  BaseText,
  Heading,
  Grid,
  ListDisplay,
  ButtonIconContextual
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { MandateType } from '@/modules/wealth/types/mandate-types';
import { moneyFormat } from '@/modules/common/helpers/currency';
import { IPortfolioDistributionResponse } from '@/modules/wallet-builder/src/services/types/models/IBffInvestments';
import { DetailType, IDetailModalProps } from '@/modules/wealth/types';
import {
  IPortfolioAbout,
  IPortfolioAboutDetails
} from '@/modules/wealth/services/portfolio';


export default /*#__PURE__*/_defineComponent({
  __name: 'AboutDetails',
  emits: ['openDetail', 'openDetailV2'],
  setup(__props, { emit }) {



const portfolioDistribution = ref<IPortfolioDistributionResponse | undefined>(
  inject<IPortfolioDistributionResponse>('portfolioDistribution')
);
const portfolioAbout = ref<IPortfolioAbout | undefined>(
  inject<IPortfolioAbout>('portfolioAbout')
);

const isEnabledBffPortfolioMigration = inject(
  'isEnabledBffPortfolioMigration'
) as Ref<boolean>;

const detailModalProps = ref<IDetailModalProps>({
  title: '',
  type: ''
});

const shouldShowDisclaimer = computed(() => {
  if (isEnabledBffPortfolioMigration.value) {
    return portfolioAbout?.value?.rows?.length > 3;
  }

  return (
    portfolioDistribution.value?.portfolio?.riskCategory &&
    portfolioDistribution.value?.portfolio?.goalDuration &&
    portfolioDistribution.value?.portfolio?.performanceFixedRate &&
    portfolioDistribution.value?.portfolio?.volatility &&
    portfolioDistribution.value?.portfolio?.maximumDrawdown
  );
});

const showNColumns = computed(() => {
  if (isEnabledBffPortfolioMigration.value) {
    return portfolioAbout.value?.rows?.length > 5 ? [1, 1] : [1];
  }

  const columnsCount = [
    portfolioDistribution.value?.portfolio?.minimumDeposit,
    portfolioDistribution.value?.portfolio?.performanceFixedRate,
    portfolioDistribution.value?.portfolio?.minimumRedemption,
    portfolioDistribution.value?.portfolio?.maximumDrawdown,
    portfolioDistribution.value?.portfolio?.goalDuration,
    portfolioDistribution.value?.portfolio?.yearlyAliquotFormatted,
    portfolioDistribution.value?.portfolio?.performanceFixedRate
  ].filter(item => item).length;
  return columnsCount > 5 ? [1, 1] : [1];
});

function openCostsDetail() {
  detailModalProps.value.title =
    portfolioDistribution?.value?.portfolio?.portfolioSummaryDetails.costs
      ?.title ?? '';
  detailModalProps.value.details = {
    description:
      portfolioDistribution?.value?.portfolio?.portfolioSummaryDetails.costs
        ?.description
  };
  detailModalProps.value.type = DetailType.Cost;

  emit('openDetail', detailModalProps.value);
}

function openMandateDetail(type: MandateType) {
  switch (type) {
    case MandateType.RiskCategory:
      detailModalProps.value.title =
        portfolioDistribution?.value?.portfolio?.portfolioSummaryDetails
          .riskCategory.title ?? '';
      detailModalProps.value.details = {
        description:
          portfolioDistribution?.value?.portfolio?.portfolioSummaryDetails
            .riskCategory?.description
      };
      break;
    case MandateType.PerformanceFixedRate:
      detailModalProps.value.title =
        portfolioDistribution?.value?.portfolio?.portfolioSummaryDetails
          .performanceFixedRate.title ?? '';
      detailModalProps.value.details = {
        description:
          portfolioDistribution?.value?.portfolio?.portfolioSummaryDetails
            .performanceFixedRate?.description
      };
      break;
    case MandateType.GoalDuration:
      detailModalProps.value.title =
        portfolioDistribution?.value?.portfolio?.portfolioSummaryDetails
          .goalDuration.title ?? '';
      detailModalProps.value.details = {
        description:
          portfolioDistribution?.value?.portfolio?.portfolioSummaryDetails
            .goalDuration?.description
      };
      break;
    case MandateType.Volatility:
      detailModalProps.value.title =
        portfolioDistribution?.value?.portfolio?.portfolioSummaryDetails
          .volatility.title ?? '';
      detailModalProps.value.details = {
        description:
          portfolioDistribution?.value?.portfolio?.portfolioSummaryDetails
            .volatility?.description
      };
      break;
    case MandateType.MaximumDrawdown:
      detailModalProps.value.title =
        portfolioDistribution?.value?.portfolio?.portfolioSummaryDetails
          .drawdown.title ?? '';
      detailModalProps.value.details = {
        description:
          portfolioDistribution?.value?.portfolio?.portfolioSummaryDetails
            .drawdown?.description
      };
      break;
  }

  detailModalProps.value.type = DetailType.Mandate;
  emit('openDetail', detailModalProps.value);
}

function openDetailModalV2(details: IPortfolioAboutDetails) {
  emit('openDetailV2', details);
}

function getMoneyFormat(value: number) {
  return moneyFormat(value, false);
}

provide('detailModalProps', detailModalProps);

return { __sfc: true,emit, portfolioDistribution, portfolioAbout, isEnabledBffPortfolioMigration, detailModalProps, shouldShowDisclaimer, showNColumns, openCostsDetail, openMandateDetail, openDetailModalV2, getMoneyFormat, BaseText, Heading, Grid, ListDisplay, ButtonIconContextual, NebraskaColors, MandateType }
}

})